import { PublicClientApplication, InteractionRequiredAuthError, EventType } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";

export const API_SCOPES = ["api://833c0ce9-ca05-4ab6-88c0-ffe82fe9d158/access_as_user"];
export const msalInstance = new PublicClientApplication(msalConfig);

// Pin the signed-in account so token requests never pick another cached one.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && "accessToken" in event.payload) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

// The driver board fires several calls at once; only the first may start a redirect,
// the rest would fail with interaction_in_progress.
let redirectStarted = false;

export async function getApiToken(): Promise<string> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("Not signed in");
  try {
    const r = await msalInstance.acquireTokenSilent({ scopes: API_SCOPES, account });
    return r.accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError && !redirectStarted) {
      redirectStarted = true;
      await msalInstance.acquireTokenRedirect({ scopes: API_SCOPES, account });
    }
    throw e;
  }
}

export async function authHeaders(): Promise<Record<string, string>> {
  return { Authorization: `Bearer ${await getApiToken()}` };
}
